export default __webpack_public_path__ + "static/media/MaharashtrianGreenPolaBangles.215c5c43.jpg";